import Swal from "sweetalert2";
import { axInst } from "../Service/Service";

// Logout function
// export const handleLogout = async (keycloak) => {
//   Swal.fire({
//     title: "Do you want to logout?",
//     icon: "warning",
//     showCancelButton: true,
//     confirmButtonColor: "#3085d6",
//     cancelButtonColor: "#d33",
//     confirmButtonText: "Logout",
//     allowOutsideClick: false,
//   }).then(async (result) => {
//     if (result.isConfirmed) {
//       try {
//         await axInst.post(`${process.env.REACT_APP_API_URL}logout`);
//         // await axInst.post("logout");

//         localStorage.clear();
//         sessionStorage.clear();

//         await keycloak.logout({
//           redirectUri: `${window.location.origin}/`,
//         });
//       } catch (error) {
//         console.error("Logout Error:", error?.message || error);
//       }
//     }
//   });
// };

export const handleLogout = async (keycloak) => {
  Swal.fire({
    title: "Do you want to logout?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Logout",
    allowOutsideClick: false,
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
        // Try logout API
        await axInst.post(`${process.env.REACT_APP_API_URL}logout`);
      } catch (error) {
        // Force logout and stop execution
        return forceLogout(keycloak);
      }
      // Clear storage
      localStorage.clear();
      sessionStorage.clear();
      // Redirect to login
      await keycloak.logout({
        redirectUri: `${window.location.origin}/`,
      });
    }
  });
};



export const handleLogoutUser = async (keycloak) => {
  try {
    // Try logout API
    await axInst.post(`${process.env.REACT_APP_API_URL}logout`);
  } catch (error) {
    // Force logout and stop execution
    return forceLogout(keycloak);
  }
  localStorage.clear();
  sessionStorage.clear();
  // Redirect to login
  await keycloak.logout({
    redirectUri: `${window.location.origin}/`,
  });
};

export const forceLogout = async (keycloak) => {
  localStorage.clear();
  sessionStorage.clear();

  await keycloak.logout({
    redirectUri: `${window.location.origin}/`,
  });
};

// Current Running Code

// export const handleLogout = async (keycloak) => {
//   Swal.fire({
//     title: "Do you want to logout?",
//     icon: "warning",
//     showCancelButton: true,
//     confirmButtonColor: "#3085d6",
//     cancelButtonColor: "#d33",
//     confirmButtonText: "Logout",
//     allowOutsideClick: false,
//   }).then(async (result) => {
//     if (result.isConfirmed) {
//       try {
//         // Redirect to login after logout
//         const res = await axInst.post(`${process.env.REACT_APP_API_URL}logout`);
//         localStorage.clear();
//         sessionStorage.clear();
//         await keycloak.logout({ redirectUri: window.location.origin + "/" });
//       } catch (error) {
//         console.error("Logout Error:", error?.message || error);
//       }
//     }
//   });
// };

// export const handleLogoutUser = async (keycloak) => {
//   try {
//     // Redirect to login after logout
//     const res = await axInst.post(`${process.env.REACT_APP_API_URL}logout`);
//     localStorage.clear();
//     sessionStorage.clear();
//     await keycloak.logout({ redirectUri: window.location.origin + "/" });
//   } catch (error) {
//     console.error("Logout Error:", error?.message || error);
//   }
// };
